import { Box } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const ModalContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4, 3),
  },
}));
